export const NO_MEMBER_TAG_VALUE = '--null--'; // player use the same convintion
export const ABANDONED_STARTER_IMPORT_SUFFIX = '_abandoned';
